let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("d0FRs"), load("9CRBg")]).then(() => parcelRequire('hCU0r'));